import React from 'react';

export default function InvestmentDetails() {
  return (
    <section className="w-full bg-black text-white py-20 px-6 md:px-10">
      <div className="max-w-4xl mx-auto space-y-14">

        {/* Section Header */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Investment Details</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            We’re currently raising a pre-seed round to launch, validate, and prepare for early revenue growth.
          </p>
        </div>

        {/* Investment Summary */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-gray-300 text-sm">

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">💸 Round</h3>
            <p>Pre-seed (friends, angels, micro-VCs)</p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">📊 Raise Target</h3>
            <p>$150,000 – $250,000</p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">📈 Use of Funds</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Tech buildout & MVP launch</li>
              <li>Legal + company formation (Dubai + India)</li>
              <li>Community onboarding & pilot marketing</li>
              <li>Advisors, UI/UX, compliance consultants</li>
            </ul>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">📄 Equity</h3>
            <p>Up to 10% of total equity for this round</p>
          </div>

        </div>

        {/* Optional Cap Table Snapshot */}
        <div className="pt-10">
          <h3 className="text-2xl font-semibold text-white mb-4">Current Cap Table Snapshot</h3>
          <ul className="text-sm text-gray-400 list-disc list-inside space-y-1">
            <li><strong>Senthil Kumar (Founder):</strong> 75%</li>
            <li><strong>Advisor Equity Pool:</strong> 10%</li>
            <li><strong>Reserved for Strategic Investors:</strong> 10%</li>
            <li><strong>Future ESOP / Team Pool:</strong> 5%</li>
          </ul>
        </div>

        {/* CTA */}
        <div className="text-center pt-10">
          <a
            href="mailto:founder@million2trillion.com"
            className="inline-block bg-purple-600 hover:bg-purple-700 text-white py-3 px-6 rounded-lg font-semibold shadow"
          >
            Request Full Investor Brief
          </a>
        </div>

      </div>
    </section>
  );
}
